import { render, staticRenderFns } from "./LayoutMockup.vue?vue&type=template&id=71198f9d&"
import script from "./LayoutMockup.vue?vue&type=script&lang=js&"
export * from "./LayoutMockup.vue?vue&type=script&lang=js&"
import style0 from "./LayoutMockup.vue?vue&type=style&index=0&id=71198f9d&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports